import { useState } from 'react'
import { Button } from '@chakra-ui/react'
import { LuTrash2 } from 'react-icons/lu'
import { showSuccess } from '@/lib/alert'
import { useRemoveAgendaMember } from '@/hooks/agendas/useRemoveAgendaMember'
import ConfirmActionDialog from '@/components/ConfirmActionDialog'
import type { AgendaMember } from '@/services/agendas'

type Props = {
  agendaId: string
  member: AgendaMember
}

const RemoveMemberButton = ({ agendaId, member }: Props) => {
  const [open, setOpen] = useState(false)
  const { mutate: remove, isPending } = useRemoveAgendaMember(agendaId)

  const handleConfirm = () => {
    remove(member.user.id, {
      onSuccess: () => {
        showSuccess('Membro removido com sucesso!')
        setOpen(false)
      },
    })
  }

  return (
    <>
      <Button colorPalette="red" variant="outline" size="xs" onClick={() => setOpen(true)}>
        <LuTrash2 />
        Remover
      </Button>

      {open && (
        <ConfirmActionDialog
          open={open}
          onOpenChange={setOpen}
          title="Remover membro"
          body={<>Tem certeza que deseja remover <strong>{member.user.name}</strong> da agenda? Esta ação não poderá ser desfeita.</>}
          onConfirm={handleConfirm}
          confirmLabel="Remover"
          confirmColorPalette="red"
          isPending={isPending}
        />
      )}
    </>
  )
}

export default RemoveMemberButton
